export * from './firstWord';
export * from './currencyRub';
export * from './truncate.pipe';
export * from './date-format.pipe'